export default {
  inject: ['load'],
  data() {
    return {
      allRespiratorySoundsForOther: [],
      respiratorySound: null,
    };
  },
  methods: {
    getListOfRespiratorySoundsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllRespiratorySounds').then(() => {
        if (this.$store.state.respiratorySoundModule.successFlag) {
          this.allRespiratorySoundsForOther =
            this.$store.state.respiratorySoundModule.allRespiratorySounds;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.respiratorySoundModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfRespiratorySoundsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getRespiratorySoundFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getRespiratorySound', id).then(() => {
        if (this.$store.state.respiratorySoundModule.successFlag) {
          this.respiratorySound = this.$store.state.respiratorySoundModule.respiratorySound;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.respiratorySoundModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getRespiratorySoundFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.respiratorySoundModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
